import React from "react";
import PropTypes from "prop-types";
import ReactAudioPlayer from "react-audio-player";

function HfnAudioPlayer(props) {
  const { Audio_Url: audioUrl, Autoplay, Title } = props;

  return (
    <div className={`Hfnaudioplayer ${Title}`}>
      <ReactAudioPlayer
        src={audioUrl}
        Autoplay={Autoplay}
        controls
        loop={false}
        preload="none"
      />
    </div>
  );
}

HfnAudioPlayer.defaultProps = {
  Autoplay: false,
};

HfnAudioPlayer.propTypes = {
  /**
   * Title is wrapper for overall component
   * */
  Title: PropTypes.string.isRequired,
  /**
   * Target Url fot the Audio
   * */
  Audio_Url: PropTypes.string.isRequired,
  /**
   * Option to auto play the Audio
   * */
  Autoplay: PropTypes.bool,
};

export default HfnAudioPlayer;
